import React from "react";

export const LogoutIcon = () => {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 9H14"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeWidth="1.1"
          stroklinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 6L14 9"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeWidth="1.1"
          stroklinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12L14 9"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeWidth="1.1"
          stroklinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 14.1875C14 16.2585 12.3719 17 10.3636 17H7.63636C5.62805 17 4 15.321 4 13.25V5.75C4 3.67893 5.62805 2 7.63636 2H10.3636C12.3719 2 14 2.74143 14 4.8125"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeWidth="1.1"
          stroklinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
